import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import useDeviceShadowStateFetcher from "../../../devices-rows/camera/useDeviceShadowStateFetcher";
import {getShadows} from "../../../../selectors/shadowSelectors";
import {normalizeStreamObject} from "../../../../selectors/device-rows/cameraSelector";
import Chip from "../../../basics/chip/Chip";
import {useTranslation} from "react-i18next";
import DevTypes from "@wesstron/utils/Api/constants/devTypes";

const CameraControlPanel = ({cameras, selectStreamId, selectedStreamId}) => {
    useDeviceShadowStateFetcher(cameras, DevTypes.CAMERA);

    const shadows = useSelector(getShadows);

    const data = useMemo(() => {
        return cameras.map(({device}) => {
            const shadow = shadows.get(device.DevID);
            return normalizeStreamObject({device, shadow});
        });
    }, [cameras, shadows]);

    const {t} = useTranslation();

    return (
        <div className="map-drawer-cctv" aria-label={t("cctv")}>
            {data.map((c) => (
                <Chip
                    color={c.streamId === selectedStreamId ? "primary" : ""}
                    key={c.streamId}
                    onClick={() => selectStreamId(c.streamId)}>
                    <div>
                        <i className="fas fa-camera-cctv fa-fw me-2" />
                        {c.streamName}
                    </div>
                    <div>
                        {c.isStreamLive && (
                            <i
                                className={
                                    "fas fa-circle color-error fa-2xs fa-fw me-1"
                                }
                            />
                        )}
                        {c.isStreamLive
                            ? t("videoPlayerStream.LIVE")
                            : c.isCameraOnline
                              ? "\xa0"
                              : t("videoPlayerStream.OFFLINE")}
                    </div>
                </Chip>
            ))}
        </div>
    );
};

export default CameraControlPanel;
